import moment from 'moment';
import { FormatDate } from '../utils/dateFormater';
import H5 from './H5';
import { formatPrice } from '../utils/formatPrice';
import React from 'react';

export default function EventCard({ event, onSelect, selected, trip }) {
  const getDays = () => {
    const start = moment(event.start_at).startOf('day');
    const end = moment(event.end_at).startOf('day');
    const days = end.diff(start, 'days');
    if (!days) return null;
    if (days === 1) return '(+ 1 day)';
    return `(+ ${days} days)`;
  };
  return (
    <div className="w-full flex-row justify-between lg:flex">
      <div className="flex flex-col justify-center">
        <H5
          className="font-poppins text-lg font-semibold"
          text={FormatDate(event?.start_at).formattedDate}
        />
        <p className="mt-1 font-sans text-base lg:text-lg">
          {`${FormatDate(event?.start_at).formattedTime} - ${
            FormatDate(event?.end_at).formattedTime
          } `}
          {getDays()}
        </p>
      </div>
      <div className="lg:hidden mt-9 mb-5 text-dark-800 ">
        <span className="font-poppins lg:text-[22px] font-semibold leading-[25.2px] text-dark-800">
          {formatPrice(trip?.attributes?.display_price)}
        </span>
        <span className="font-sans text-base font-normal leading-[22.4px]"> / person</span>
      </div>
      <div className="flex items-center lg:justify-end lg:p-0">
        <button
          onClick={onSelect}
          className="rounded-full bg-tertiary-main px-[16px] py-[12px] font-poppins text-sm font-medium"
          type="button"
        >
          {selected ? 'Selected' : 'Choose'}
        </button>
      </div>
    </div>
  );
}
